"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    "route-users": {
        en: "Route User",
        es: "Usuario de Ruta",
    },
    optimusRoutes: {
        en: 'Optimus Routes',
        es: 'Optimus Routes',
    },
    shareSms: {
        en: "Share by sms",
        es: "Compartir por mensaje de texto",
    },
    sendInvite: {
        en: "Send invite",
        es: "Enviar invitación",
    },
    city: {
        en: "City",
        es: "Ciudad",
    },
    cityRequired: {
        en: "City is required.",
        es: "La ciudad es requerida",
    },
    zipCode: {
        en: "Zip Code",
        es: "Código Postal",
    },
    zipCodeRequired: {
        en: "Zip code is required.",
        es: "El Código postal es requerido",
    },
    areaCode: {
        en: "Country code",
        es: "Código de país",
    },
    stateRequired: {
        en: "State is required.",
        es: "El estado es requerido",
    },
    numberRequired: {
        en: "Phone is required.",
        es: "El teléfono es requerido.",
    },
    nameRequired: {
        en: "Name is required.",
        es: "El nombre es requerido.",
    },
    addressRequired: {
        en: "Address is required.",
        es: "La dirección es requerida.",
    },
    phoneAlreadyExist: {
        en: "Phone already exist.",
        es: "El teléfono ya existe.",
    },
    newCellularDevice: {
        en: "New Cellular Device",
        es: "Nuevo Dispositivo Celular",
    },
    cellularDevice: {
        en: "Cellular Device",
        es: "Dispositivo Celular",
    },
    cellularDeviceInfo: {
        en: "Team member information",
        es: "Información de miembro del equipo",
    },
    newDelivery: {
        en: "New Delivery",
        es: "Nueva Entrega",
    },
    schedule: {
        en: "Schedule",
        es: "Planificador",
    },
    otpList: {
        en: "Login code List",
        es: "Lista de códigos de inicio de sesión",
    },
    shareApp: {
        en: "Download app, Android: {android} Apple: {apple}",
        es: "Descarga el app, Android: {android} Apple: {apple}",
    },
    languageRequired: {
        en: "Language is required.",
        es: "El lenguaje es requerido.",
    },
    genderRequired: {
        en: "Gender is required.",
        es: "El genero es requerido.",
    },
    cellularDevices: {
        en: "Cellular Devices",
        es: "Dispositivos Celulares",
    },
    teamMembers: {
        en: "Team members",
        es: "Miembros de equipo",
    },
    lastLogIn: {
        en: "Last Login",
        es: "Ultima session",
    },
    seeOtp: {
        en: "Generate new login code",
        es: "Generar nuevo código de inicio de sesión",
    },
    routeDriverSearchPlaceholder: {
        en: "Search by Name and Phone",
        es: "Buscar por Nombre y teléfono",
    },
    phoneModel: {
        en: "Phone Model",
        es: "Modelo de Teléfono",
    },
    phoneOS: {
        en: "Operating System",
        es: "Sistema Operativo",
    },
    copyOtp: {
        en: "Copy login code",
        es: "Copiar código de inicio de sesión",
    },
    otpShareDescription: {
        en: "Share this login code with the person that need to login for the first time.",
        es: "Comparte el código de inicio de sesión con la persona que necesita iniciar sesión por primera vez.",
    },
    taskTitle: {
        en: "Title",
        es: "Titulo",
    },
    taskTitlePlaceholder: {
        en: "Type the task title",
        es: "Ingrese el titulo de la tarea",
    },
    taskTypePlaceholder: {
        en: "Select the task type",
        es: "Seleccione el tipo de tarea",
    },
    taskStatusPlaceholder: {
        en: "Select the task status",
        es: "Seleccione el estado de la tarea",
    },
    contact: {
        en: "Contact",
        es: "Contacto",
    },
    task: {
        en: "Task",
        es: "Tarea",
    },
    setDueDate: {
        en: "Set Due Date",
        es: "Establecer Fecha programada",
    },
    dueDateDescription: {
        en: "This will be the due date assigned to the imported tasks",
        es: "Esta será la fecha asignada a las tareas importadas",
    },
    dueDate: {
        en: "Due Date",
        es: "Fecha programada",
    },
    dueDateRequired: {
        en: "Due Date is required",
        es: "Fecha programada es requerida",
    },
    taskTitleRequired: {
        en: "Title is required.",
        es: "El titulo es requerido.",
    },
    descriptionRequired: {
        en: "Description is required.",
        es: "la descripción es requerida.",
    },
    contactRequired: {
        en: "Contact is required.",
        es: "El contacto es requerido.",
    },
    phoneIsNotUsaValid: {
        en: "Phone is not a valid U.S. number.",
        es: "El teléfonos no es valido para Estados Unidos.",
    },
    activeSince: {
        en: "Active since {from}.",
        es: "Activo hace {from}.",
    },
    taskCount: {
        en: "{taskCount, plural, =0 {# tasks assigned.} one {# assigned task.} other {# tasks assigned.}}",
        es: "{taskCount, plural, =0 {# tareas asignadas.} one {# tarea asignada.} other {# tareas asignadas.}}",
    },
    allLoaded: {
        en: "Nothing more to load.",
        es: "Nada más que cargar.",
    },
    tasks: {
        en: "Tasks",
        es: "Tareas",
    },
    tasksCt: {
        en: "{tasksCt, plural, =0 {# tasks} one {# task} other {# tasks}}",
        es: "{tasksCt, plural, =0 {# tareas} one {# tarea} other {# tareas}}",
    },
    confirmTaskUnassignDescription: {
        en: "Are you sure you want to Unassign {taskCount, plural, =0 {# tasks} one {# task} other {# tasks}}?",
        es: "Esta seguro que quiere Desasignar {taskCount, plural, =0 {# tareas} one {# tarea} other {# tareas}}?",
    },
    assignTo: {
        en: "Assign to",
        es: "Asignar a",
    },
    assignToError: {
        en: "You must check al least one before continuing",
        es: "Debe seleccionar al menos uno antes de continuar",
    },
    assignSelected: {
        en: "Assign selected",
        es: "Asignar seleccionados",
    },
    unAssignSelected: {
        en: "Unassign selected",
        es: "Desasignar seleccionados",
    },
    newTask: {
        en: "New Task",
        es: "Tarea Nueva",
    },
    assigned: {
        en: "Assigned",
        es: "Asignada",
    },
    skipped: {
        en: "Skipped",
        es: "Omitida",
    },
    unassigned: {
        en: "Unassigned",
        es: "Sin asignar",
    },
    assignedNotCompleted: {
        en: 'Your task was Assigned but not Completed',
        es: 'Su tarea fue Asignada pero no Completada'
    },
    assignedTasks: {
        en: 'Assigned',
        es: 'Asignadas',
    },
    doneTasks: {
        en: 'Completed',
        es: 'Completadas',
    },
    skippedTasks: {
        en: 'Skipped',
        es: 'Omitidas',
    },
    unassignedTasks: {
        en: 'Unassigned',
        es: 'Sin asignar',
    },
    uncompletedTasks: {
        en: 'Uncompleted',
        es: 'Sin completar',
    },
    taskOfTheDay: {
        en: 'Task of the Day',
        es: 'Tareas del Día',
    },
    quickAccess: {
        en: 'Quick access',
        es: 'Acceso rápido',
    },
    noTaskForToday: {
        en: "Everything's up to date",
        es: 'Todo se encuentra al día',
    },
    noUnassignedTasks: {
        en: "No Unassigned Tasks",
        es: 'No hay tareas Sin Asignar',
    },
    noUncompletedTasks: {
        en: "No Uncompleted Tasks",
        es: 'No hay tareas Sin Completar',
    },
    taskManagement: {
        en: 'Tasks management',
        es: 'Administrador de Tareas',
    },
    taskPlanner: {
        en: 'Task planner',
        es: 'Planificador de tareas',
    },
    service: {
        en: "Type of service",
        es: "Tipo de servicio",
    },
    phoneNumber: {
        en: "Phone number",
        es: "Número de teléfono",
    },
    country: {
        en: "Country",
        es: "País",
    },
    mapMessage: {
        en: "You can double click on map or drag marker to locate pin in the desired location.",
        es: "Puedes hacer doble click sobre el mapa o mover el marcador en tu ubicación deseada.",
    },
    createDriver: {
        en: "New team member",
        es: "Nuevo miembro del equipo",
    },
    editDriver: {
        en: "Edit team member",
        es: "Editar miembro de equipo",
    },
    routing: {
        en: "Routing",
        es: "Ruteo",
    },
    tracking: {
        en: "Tracking",
        es: "Rastreo",
    },
    saveChanges: {
        en: "Save changes",
        es: "Guardar cambios",
    },
    workSchedule: {
        en: "Work schedule",
        es: "Horario de trabajo",
    },
    notAvailable: {
        en: "Not available",
        es: "No disponible",
    },
    driverInformation: {
        en: "Personal information",
        es: "Información personal",
    },
    review: {
        en: "Review",
        es: "Revisión",
    },
    phone: {
        en: "Phone",
        es: "Teléfono",
    },
    action: {
        en: "Action",
        es: "Acción",
    },
    searchRouteUser: {
        en: 'Search team member',
        es: 'Buscar miembro del equipo'
    },
    optimizeRoute: {
        en: "Optimized",
        es: "Optimizar",
    },
    optimizeRouteTitle: {
        en: "Optimize Route",
        es: "Optimizar Ruta",
    },
    optimizeTasks: {
        en: "Optimize Tasks",
        es: "Optimizar Tareas"
    },
    optimizeTasksPrompt: {
        en: "Do you want to Optimize all the Tasks of {userName}",
        es: "Desea Optimizar todas las Tareas de {userName}"
    },
    optimizeRouteSubtitle: {
        en: 'This will give the tasks an order in which they`ll be completed',
        es: 'Esto le dará a las tareas el orden en el que serán completadas',
    },
    uneligibleDriversDisclamer: {
        en: "Some team members will not be eligible, because of their schedule or have at least one task assigned to them.",
        es: "Algunos miembros del equipo no podrán ser seleccionados por su horario o porque tienen asignada una tarea al menos",
    },
    considerReturn: {
        en: "Consider Return",
        es: "Considerar retorno",
    },
    considerReturnDisclamer: {
        en: "All vehicles return location, will be considered in the Optimization ",
        es: "A todos los vehículos se les considerara el retorno en la optimización.",
    },
    disabled: {
        en: 'Disabled',
        es: 'Deshabilitado'
    },
    offline: {
        en: "Offline",
        es: "Desconectado",
    },
    online: {
        en: "Online",
        es: "Conectado",
    },
    offlineTime: {
        en: "{timeDifferenceHours} {unit} ago",
        es: "Hace {timeDifferenceHours} {unit}",
    },
    autocomplete: {
        en: "Autocomplete",
        es: "Autocompletar",
    },
    infoAutocomplete: {
        en: "Type your address in order to autocomplete the rest of the fields",
        es: "Escriba su dirección para autocompletar el resto de los campos",
    },
    infoPoi: {
        en: "Type and select one of the available Points of interest",
        es: "Escriba y seleccione uno de los Puntos de interés disponibles",
    },
    infoManual: {
        en: "Fill out the form manually with your desired the data",
        es: "Llene el formulario de manera manual con los campos que desea",
    },
    type: {
        en: "Type",
        es: "Tipo",
    },
    createTask: {
        en: "Create new task",
        es: "Crear nueva tarea",
    },
    editTask: {
        en: "Edit Task",
        es: "Editar Tarea",
    },
    viewTaskInfo: {
        en: "View Task",
        es: "Ver Tarea",
    },
    taskInformation: {
        en: "Task Information",
        es: "Información de Tarea",
    },
    taskContactName: {
        en: "Contact name",
        es: "Nombre de contacto",
    },
    customerContact: {
        en: "Customer phone",
        es: "Teléfono de cliente"
    },
    customerName: {
        en: "Customer name",
        es: "Nombre de cliente",
    },
    createdDate: {
        en: "Created Date",
        es: "Día de Creación",
    },
    assignedTask: {
        en: "Assigned Tasks:",
        es: "Tareas Asignadas:",
    },
    deallocate: {
        en: "Unassign",
        es: "Desasignar",
    },
    repeat: {
        en: "Repeat",
        es: "Repetir",
    },
    oneTimeOnly: {
        en: "One time only",
        es: "Una sola vez",
    },
    everyday: {
        en: "Everyday",
        es: "Todos los días",
    },
    everyWeekDay: {
        en: "Every weekday",
        es: "Lunes a Viernes",
    },
    everyWeek: {
        en: "Every week",
        es: "Cada semana",
    },
    everyMonth: {
        en: "Every month",
        es: "Cada mes",
    },
    view: {
        en: "View",
        es: "Ver"
    },
    doneTask: {
        en: "Completed",
        es: "Completada"
    },
    delivery: {
        en: "Delivery",
        es: "Entrega"
    },
    pickup: {
        en: "Pickup",
        es: "Recoger"
    },
    doesRepeat: {
        en: "Repeat",
        es: "Se repite"
    },
    doNotRepeat: {
        en: "Do not repeat",
        es: "No se repite"
    },
    repeatEvery: {
        en: "Repeat every",
        es: "Se repite los",
    },
    taskOccurrDays: {
        en: "Task will occur on days",
        es: "La tarea ocurrirá en los días"
    },
    startingOn: {
        en: "Starting on",
        es: "Empieza el día"
    },
    excecutedOn: {
        en: "Will be executed every",
        es: "Se ejecutará cada",
    },
    taskFrequency: {
        en: "Frequency",
        es: "Frecuencia"
    },
    terminateAt: {
        en: "Terminate at",
        es: "Termina"
    },
    everyMonthAt: {
        en: "Repeat every month at",
        es: "Repetir cada mes en"
    },
    trackedPhonesDescription: {
        en: "These are the devices that will be tracked, each of them will be assigned a Staff profile",
        es: "Son los dispositivos que se rastrearán, a estos le será asignado un perfil del Staff"
    },
    accountDescription: {
        en: "The Users are accounts linked to this administrator account, as an admin you can create, modify or edit the users list",
        es: "Los Usuarios son cuentas vinculadas a tu cuenta administrador, como administrador puedes crear, modificar o editar la lista de estas cuentas"
    },
    staffDescription: {
        en: "The Staff members are the driver\'s profiles, and they will be linked to the team members",
        es: "Los Staff son los perfiles de los drivers, los staff se vincularán a los miembros del equipo"
    },
    taskForce: {
        en: "Team members",
        es: "Equipo de trabajo"
    },
    importTasks: {
        en: "Import tasks",
        es: "Importar tareas",
    },
    importCsv: {
        en: 'Import CSV',
        es: 'Importar CSV'
    },
    importTasksReminder: {
        en: "Remember your file must be in the template structure mentioned above and in a xlsx or csv format.",
        es: "Recuerde que su archivo debe seguir la estructura de la plantilla mencionada anteriormente, en formato xlsx o csv."
    },
    importTasksRateSuccess: {
        en: "saved",
        es: "guardados"
    },
    importTasksRateFailed: {
        en: "failed",
        es: "fallidos"
    },
    importTasksDrag: {
        en: "Click or drag file to this area to load the file",
        es: "Haga click o arrastre el archivo a esta area para cargar el archivo",
    },
    totalTasks: {
        en: "Total tasks:",
        es: "Total de tareas:"
    },
    successTasks: {
        en: "Success tasks:",
        es: "Tareas exitosas:"
    },
    failedTasks: {
        en: "Failed tasks:",
        es: "Tareas fallidas:"
    },
    failedTaskUpload: {
        en: "Failed Uploads",
        es: "Cargas de archivos fallidos"
    },
    failedTasksMessage: {
        en: "The following file contains the records of the data that couldn\'t be uploaded due to missing data or wrong format.",
        es: "El siguiente archivo contiene los registros de los datos que no se pudieron subir debido a que faltan datos o al tienen un formato incorrecto."
    },
    failedTaskSecondMessage: {
        en: "You can check out the file, correct it and upload it again.",
        es: "Puede consultar el archivo, corregirlo y subirlo nuevamente."
    },
    templateFilesDescription: {
        en: "Upload your tasks in a file with xlsx or csv format. Take into account that your file must follow one of the following templates:",
        es: "Suba sus tareas en un archivo con formato xlsx o csv. Tenga en cuenta que su expediente debe seguir una de las siguientes plantillas:"
    },
    taskCvsTemplate: {
        en: "CSV example template.csv",
        es: "Plantilla de ejemplo en CSV.csv"
    },
    taskXlsxTemplate: {
        en: "Spreadsheet example template.xlsx",
        es: "Plantilla de ejemplo en excel.xlsx"
    },
    uploadingTasks: {
        en: "Your tasks are being uploaded",
        es: "Sus tareas están siendo subidas"
    },
    assignOptimizedResult: {
        en: "{taskCount, plural, one {The task has} other {tasks have}} been added to {taskCount, plural, one {this team member} other {these team members}}",
        es: "{taskCount, plural, one {La tarea ha} other {tareas han}} sido añadidas a {taskCount, plural, one {este miembro del equipo} other {estos miembros del equipo}}",
    },
    assignMassiveTasks: {
        en: "The tasks were successfully assigned",
        es: "Las tareas fueron asignadas correctamente"
    },
    assignOptimizedCero: {
        en: "No tasks were assigned",
        es: "Ninguna tarea fue asignada"
    },
    tasksNotScheduled: {
        en: "Tasks were not assigned",
        es: "No fueron asignadas"
    },
    tasksNotScheduledDescription: {
        en: "Some tasks failed to be assigned, you can check the cards of the failed tasks in box below and try to re-assign them.",
        es: "Algunas tareas no pudieron ser asignadas, puedes seleccionar las casillas de las tarjetas fallidas e intentar asignarlas de nuevo."
    },
    tasksScheduledWarning: {
        en: "Take in note that some tasks can fail to be assign due to location or drivers capacity",
        es: "Tenga en en cuenta que algunas tareas no pueden ser asignadas debido a la ubicación o la capacidad de los conductores"
    },
    reAssignTasks: {
        en: "Re-assign",
        es: "Re-asignar"
    },
    assignTasks: {
        en: "Yes, assign",
        es: "Sí, asignar"
    },
    noTasksAssigned: {
        en: 'No task was assigned',
        es: 'Ninguna tarea fue asignada'
    },
    assignPreview: {
        en: 'Assign preview',
        es: 'Vista previa a Asignar'
    },
    assignResult: {
        en: 'Assign Result',
        es: 'Resultado de asignación'
    },
    downloadRoutesAppTop: {
        en: 'Download',
        es: 'Descarga'
    },
    downloadRoutesAppBottom: {
        en: 'Optimus Routes App',
        es: 'La Aplicación Optimus Routes'
    },
    directLink: {
        en: 'Direct Link',
        es: 'Link Directo'
    },
    directLinkDescription: {
        en: 'You can share the invite link for the Optimus app with your driver',
        es: 'Puedes compartir con tu conductor el link de invitación a la app de Optimus'
    },
    copyLink: {
        en: 'Copy invite link',
        es: 'Copiar invitación'
    },
    viaSms: {
        en: 'Via SMS',
        es: 'Vía SMS'
    },
    viaSmsDescription: {
        en: 'Or send a direct message to invite your driver to download the app',
        es: 'O envíe un link directo a su conductor para que se descargue a la aplicación'
    },
    inviteSent: {
        en: 'Invite sent',
        es: 'Invitación enviada'
    },
    copyingLink: {
        en: 'Generating invite link',
        es: 'Generando link de invitación'
    },
    linkCopied: {
        en: "Link copied to clipboard",
        es: "El link se copió correctamente",
    },
    shareMobileApp: {
        en: 'Share mobile app',
        es: 'Compartir app movil'
    },
    downloadAppSms: {
        en: 'Download Optimus Routes on the following link {downloadLink}',
        es: 'Descarga Optimus Routes en el siguiente enlace {downloadLink}'
    },
    shareLoginCode: {
        en: 'Access code',
        es: 'Código de acceso'
    },
    generateAccessCode: {
        en: 'Generate access code',
        es: 'Generar código de acceso'
    },
    generateCodeAgain: {
        en: 'Generate code again',
        es: 'Generar código de nuevo'
    },
    profileOverview: {
        en: 'Profile overview',
        es: 'Resumen de perfil'
    },
    shareAppLink: {
        en: 'Share app link',
        es: 'Compartir link de aplicación'
    },
    shareAppLinkDescription: {
        en: 'Send invite to your drivers to download Optimus Routes App',
        es: 'Invite a sus conductores a descargar la aplicación Optimus Routes'
    },
    sendingMessage: {
        en: 'Sending message',
        es: 'Enviando mensaje'
    },
    startingPointWarning: {
        en: 'Keep in mind this address would be your starting point',
        es: 'Tenga en cuenta que este será su punto de inicio'
    },
    nameFilterPlaceholder: {
        en: 'Type your name',
        es: 'Escriba su nombre'
    },
    phoneFilterPlaceholder: {
        en: 'Type your phone',
        es: 'Escriba su teléfono'
    },
    statusPlaceholder: {
        en: 'Select a status',
        es: 'Seleccione un estado'
    },
    enableDriver: {
        en: 'Enable',
        es: 'Habilitado'
    },
    toolbarNewTask: {
        en: 'New task',
        es: 'Nueva tarea'
    },
    toolbarDefaultLayer: {
        en: 'Default',
        es: 'Predeterminado'
    },
    location: {
        en: 'Location',
        es: 'Ubicación'
    },
    assignedTo: {
        en: 'Assigned To',
        es: 'Asignado a'
    },
    notAssigned: {
        en: 'Not assigned',
        es: 'Sin asignar'
    },
    noDescription: {
        en: 'No description',
        es: 'Sin descripción'
    },
    taskOverview: {
        en: 'Task overview',
        es: 'Resumen de tarea'
    },
    driverDeviceInformation: {
        en: 'Device Information',
        es: 'Información del dispositivo'
    },
    accessFineLocation: {
        en: 'Access fine location',
        es: 'Acceso a ubicación precisa'
    },
    motion: {
        en: 'Motion',
        es: 'Movimiento'
    },
    notificationPermission: {
        en: 'Notifications',
        es: 'Notificaciones'
    },
    ignoreBattery: {
        en: 'Ignore battery optimization',
        es: 'Ignorar optimización de batería'
    },
    powerManager: {
        es: 'Gestor de energía',
        en: 'Power manager'
    },
    grantedPermissions: {
        en: 'Granted Permissions',
        es: 'Permisos concedidos'
    },
    expiredDateTooltip: {
        en: 'Expired task',
        es: 'Tarea expirada'
    },
    upcomingDateTooltip: {
        en: 'Task almost on its due date',
        es: 'Tarea está a punto de expirar'
    },
    todaysDateTooltip: {
        en: 'Task is due today',
        es: 'Tarea vence hoy'
    },
    stateScheduler: {
        en: 'State/Region',
        es: 'Estado/Región'
    },
    statusScheduler: {
        en: 'Task status',
        es: 'Estado de tarea'
    },
    oldDatesDisabled: {
        en: 'This action is not available on past dates',
        es: 'Esta ación no es posible en fechas pasadas'
    },
    taskDeleted: {
        en: 'Task successfully deleted',
        es: 'Tarea eliminada'
    },
    unassign: {
        en: "Unassign",
        es: "Desasignar",
    },
    buy: {
        en: "Buy",
        es: "Comprar",
    },
    wouldYouLikeToBuyMore: {
        en: "Would you like to buy more?",
        es: "¿Te gustaría comprar más?",
    },
    noAvailableSeatsFeedback: {
        en: "Hey! No available seats",
        es: "¡Hey! No hay asientos disponibles",
    },
    seatsUsed: {
        en: "Seats Used",
        es: "Asientos Utilizados",
    },
    membersSeatsBilling: {
        en: "Members Seats Billing",
        es: "Facturación de Asientos para Miembros",
    },
    newSeatDescription: {
        en: "New seat at ${dollar}/month each",
        es: "Nuevo asiento a ${dollar} al mes cada uno",
    },
    deallocateSingleTask: {
        en: "Are you sure you want to unassign task {taskTitle}?",
        es: "¿Está seguro que quiere desasignar la tarea {taskTitle}?",
    },
    busyRouteUser: {
        en: "{routeUser} it's assigned to another device, assign to this device anyway?",
        es: "{routeUser} está asignado a otro vehículo, ¿Asignar a este vehículo de todas formas?",
    },
    selectRouteUser: {
        en: "Select a route user",
        es: "Selecciona un usuario de ruta",
    },
    emptyRouteUser: {
        en: "You should select a route user",
        es: "Debes seleccionar un usuario de ruta",
    },
    assingToDevice: {
        en: "Assign to device",
        es: "Asignar a dispositivo"
    },
    busyDevice: {
        en: "{device} it's assigned to another member, assign to this member anyway?",
        es: "{device} está asignado a otro miembro, ¿Asignar a este miembro de todas formas?",
    },
    sortTasks: {
        en: "Sort Tasks Manually",
        es: "Ordenar Tareas Manualmente"
    },
    sortTasksMessage: {
        en: "Move and sort the tasks in the order you want them to be completed",
        es: "Mueva y ordene las tareas en el orden que desea que sean completadas"
    },
    reorderTasks: {
        en: 'Reorder manually',
        es: 'Reordenar manualmente'
    },
    orderChanged: {
        en: 'Task were reordered successfully',
        es: 'Las tareas fueron re-ordenadas correctamente'
    },
    selectedTasks: {
        en: 'All {selectedTasks} tasks on this page are selected.',
        es: 'Todas las {selectedTasks} tareas en esta página fueron seleccionadas'
    },
    selectAllTasks: {
        en: 'Select all {totalTasks} tasks',
        es: 'Seleccionar todas las {totalTasks} tareas'
    },
    modifyDueDate: {
        en: 'Modify Due Date',
        es: 'Cambiar Fecha Progamada'
    },
    modifyDueDateSelected: {
        en: 'Modify the due date of the {selectedTasks, plural, =0 {selected task} one {selected task} other {# selected tasks}}',
        es: 'Cambiar fecha progamada de {selectedTasks, plural, =0 {la tarea seleccionada} one {la tarea seleccionada} other {las # tareas seleccionadas}}'
    },
    assignedTaskCount: {
        en: '{count, plural, =0 {# Tasks} one {# Task} other {# Tasks}}',
        es: '{count, plural, =0 {# Tareas} one {# Tarea} other {# Tareas}}'
    },
    routeUserHasNoTasks: {
        en: '{unit}, no tiene tareas asignadas para fecha seleccionada',
        es: '{unit}, you have no tasks assigned for the selected date'
    },
    deleteTasks: {
        en: '{quantity, plural, =0 {Task} one {Task} other {Tasks}} successfully deleted',
        es: '{quantity, plural, =0 {Tarea} one {Tarea} other {Tareas}} eliminadas con éxito',
    },
    updateTasks: {
        en: '{quantity, plural, =0 {Task} one {Task} other {Tasks}} successfully updated',
        es: '{quantity, plural, =0 {Tarea} one {Tarea} other {Tareas}} actualizadas con éxito',
    },
    updateAllTasks: {
        en: 'Edit due date of all selected tasks?',
        es: '¿Editar la fecha programada de todas las tareas seleccionadas?'
    },
    allTasksSelected: {
        en: 'All {quantity} tasks from the table are selected.',
        es: 'Todas las {quantity} tareas de la tabla fueron seleccionadas.'
    },
    tasksInProgress: {
        en: 'Tasks in Progress',
        es: 'Tareas en Progreso'
    },
    workingHours: {
        en: "Working Hours",
        es: "Horario de trabajo",
    },
    dayOff: {
        en: "Day off",
        es: "Día Libre",
    },
    teamProgress: {
        en: "Team Members Progress",
        es: "Progreso del Equipo de Trabajo",
    },
};
exports.default = translations;
